import { STATUS_FORM_SENT_SUCCESS, STATUS_FORM_ERROR } from '../constants.js';

const defaultState = {
    formSentSuccess: false,
    formSentText: '',
    errors: {},
}

export const formStatus = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case STATUS_FORM_SENT_SUCCESS:
        case STATUS_FORM_ERROR:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}